<template>
  <v-alert id="data-table-search-no-results" icon="warning">
    {{ $t("tables.SearchMessageInitial") }} "{{ search }}"
    {{ $t("tables.SearchMessageEnd") }}
  </v-alert>
</template>

<script>
export default {
  name: "DataTableNoResults",

  props: {
    /**
     * The value of the search
     */
    search: {
      type: String
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_Atoms/DataTableNoResults.vue